import {
  useWSModal,
  WSForm,
  WSInputText
} from "@wingspanhq/fe-component-library";
import React from "react";
import * as Yup from "yup";
import { queriesComplianceEntities } from "@query";
import { validatorName } from "../../../../../shared/validators/validatorName";
import { LayoutFormEdit } from "./LayoutFormEdit";

type FormData = { newValue: string };

type Props = {
  onClose: () => void;
};

export const FormEditPreferredName: React.FC<Props> = props => {
  const queryComplianceEntities =
    queriesComplianceEntities.listComplianceEntities.useQuery({});
  const primaryEntity = queryComplianceEntities.data?.data?.find(
    entity => !entity.subject
  );
  const [mutate, meta] =
    queriesComplianceEntities.updateComplianceEntity.useMutation({
      dependencies: [
        queriesComplianceEntities.listComplianceEntities.queryKeyBase
      ],
      onSuccess: props.onClose
    });

  return (
    <WSForm<FormData>
      defaultValues={{
        newValue: primaryEntity?.preferredName || ""
      }}
      onSubmit={data => {
        if (!primaryEntity?.id) {
          return;
        }

        mutate({
          complianceEntityId: primaryEntity.id,
          complianceEntityUpdate: { preferredName: data.newValue }
        });
      }}
      validationSchema={Yup.object({ newValue: validatorName })}
    >
      <LayoutFormEdit
        isLoading={meta.isLoading}
        error={meta.error}
        onCancel={props.onClose}
      >
        <WSForm.Field
          name="newValue"
          label="Preferred name (optional)"
          component={WSInputText}
        />
      </LayoutFormEdit>
    </WSForm>
  );
};

export const useModalEditPreferredName = () =>
  useWSModal(FormEditPreferredName, {
    title: "Preferred name",
    size: "S"
  });
